/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Cashback, VatVerificationInfo } from './cashbackClient.typings';
import apiClient from '../apiClient';

async function getDocumentCashbackInfo(documentId: string): Promise<Cashback> {
    return apiClient.get<Cashback>(`1.0.0/cashback/${documentId}`);
}

async function getVatVerificationInfo(documentId: string): Promise<VatVerificationInfo> {
    return apiClient.get<VatVerificationInfo>(`1.0.0/cashback/${documentId}/verify`);
}

export const cashbackClient = {
    getDocumentCashbackInfo,
    getVatVerificationInfo,
};
